import React, { useState, useEffect } from "react";
import {
  Button,
  MenuItem,
  Select,
  Typography,
  Box,
  Container,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getStockByCategory } from "../Services/DashboardService";
import { generatePDFReport } from "../Services/CommonService";
import Footer from "../Footer/Footer";

interface StockItem {
  name: string;
  stock: number;
}

interface CategoryStock {
  categoryName: string;
  totalStock: number;
  items: StockItem[];
}

const CategoryWiseStockReport = () => {
  const [stockFilter, setStockFilter] = useState("availableQty");
  const [stockData, setStockData] = useState<CategoryStock[]>([]);
  const [loading, setLoading] = useState(false);
  const orgId = localStorage.getItem("orgId") || "";
  const orgName = localStorage.getItem("orgName") || "My Organization";
  const orgAddress = localStorage.getItem("orgDetails") || "";

  const fetchStockData = async () => {
    setLoading(true);
    try {
      const response = await getStockByCategory(orgId, stockFilter);
      console.log("Fetched Stock Data:", response);
      setStockData(response || []);
    } catch (error) {
      console.error("Error fetching stock by category:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (stockFilter) {
      fetchStockData();
    }
  }, [stockFilter]);

  const formattedRows = stockData.flatMap((category, catIndex) =>
    (category.items || []).map((item, itemIndex) => ({
      id: `${catIndex}-${itemIndex}`,
      categoryName: category.categoryName || "Unknown",
      itemName: item.name || "Unknown Item",
      stock: item.stock ?? 0,
    }))
  );

  const columns = [
    { field: "id", headerName: "Sn", width: 70 },
    { field: "categoryName", headerName: "Category Name", width: 200, flex: 1 },
    { field: "itemName", headerName: "Item Name", width: 250, flex: 1 },
    { field: "stock", headerName: "Stock", width: 120 },
  ];

  const downloadPDF = () => {
    if (formattedRows.length === 0) {
      alert("No data available to generate a report.");
      return;
    }

    const columns = ["Sn.", "Category Name", "Item Name", "Stock"];
    const data = formattedRows.map((item, index) => [
      index + 1,
      item.categoryName,
      item.itemName,
      item.stock,
    ]);

    generatePDFReport(
      "Category-wise Stock Report",
      orgName,
      orgAddress,
      columns,
      data,
      ""
    );
  };

  return (
    <>
      <div className="page-location">
        <span>Reports &gt; Item Stock Report</span>
      </div>
      <Container maxWidth="lg" sx={{ padding: 1 }}>
        <Box sx={{ textAlign: "center", p: 3 }}>
          <Typography
            variant="h4"
            sx={{ mb: 2, fontWeight: "bold", color: "#000000" }}
          >
            Category-wise Stock Report
          </Typography>
          <Select
            value={stockFilter}
            onChange={(e) => setStockFilter(e.target.value)}
            displayEmpty
            sx={{
              width: 250,
              mb: 2,
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              "& .MuiSelect-select": { padding: "10px" },
            }}
          >
            {/* <MenuItem value="" disabled>
                  Select Filter
              </MenuItem> */}
            <MenuItem value="availableQty">Available Stocks</MenuItem>
            <MenuItem value="outOfStocks">Out of Stocks</MenuItem>
            <MenuItem value="lowStocks">Low Stocks</MenuItem>
            <MenuItem value="allStocks">All Stocks</MenuItem>
          </Select>

          <DataGrid
            rows={formattedRows}
            columns={columns.map((col) => ({
              ...col,
              headerClassName: "super-app-theme--header",
              headerStyle: { fontWeight: "bold" },
            }))}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 5 },
              },
            }}
            pageSizeOptions={[5, 10, 20]}
            autoHeight
            loading={loading}
            sx={{
              "& .super-app-theme--header": {
                fontWeight: "bold",
              },
            }}
          />
          <Button
            variant="contained"
            color="secondary"
            onClick={downloadPDF}
            sx={{
              m: 1,
              p: 1,
            }}
          >
            Download PDF
          </Button>
        </Box>
      </Container>
      <Box
        sx={{
          position: "relative",
          left: 0,
          bottom: 0,
          width: "100%",
          mt: 10,
        }}
      >
        <Footer />
      </Box>
    </>
  );
};
export default CategoryWiseStockReport;
